/**
 * Mixins provide common hooks to share across all components.
 * Reference:
 * https://vuejs.org/v2/guide/mixins.html
 *
 * global.js is used to map store functions
 */
import Vue from 'vue';
import { mapState, mapGetters} from 'vuex';

export const storeMapper = {
    computed: {
        //mapState alias. With this setting, we can access the store state by using this.storeSample.someState in the component.
        ...mapState({
            storeCate: state => state.cate,
            storeMainSite: state => state.mainSite,
            storeBanner: state => state.banner,
            storeMyDownload: state => state.my_download_store,
            storeResource: state => state.resource_store,
            //storeSample: state => state.sample,  //TODO: sample, not used, to be removed
            storePhotoGallery: state => state.photo_gallery
        }),
        //mapState alias. With this setting, we can access the store state by using this.storeSample.someState in the component.
        //getters of namespaced module are in this format: 'STORE_NAME/GETTER_FUNCTION_NAME'
        ...mapGetters(
            [
                'resource_store/total',
                'resource_store/total_select_overall',
                'resource_store/total_size_overall',
                'resource_store/select_num_of_new_resource',
                'resource_store/check_all_status',
                'mainSite/getRelatedLangStr',
                //'sample/testGetter1', //TODO: sample, not used, to be removed,
                //'sample/testGetter2', //TODO: sample, not used, to be removed,
                'mainSite/getRelationURL',
                'mainSite/getDefaultRelationURL'

            ]
        ),
        //Sample mapGetter alias. If you really want a 'shortcut' path, you can consider declaring like the following and access with this.sampleTestGetter1
        ...mapGetters({
            //sampleTestGetter1:'sample/testGetter1'
        })
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/storeMapper.js